/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { StoreDataCache, findCache, saveCache } from '@/store/cache';
import { StoreActionEnv, finalizeAction, ActionType } from '@/store/actions';

export interface SecretNavCache {
  group: string;
  navs: api.SecretNavData[];
}

export interface StoreSecretNavState {
  cache: StoreDataCache<SecretNavCache>[];
  maxCache: number;
}

export default {
  namespaced: true,
  state: {
    cache: [],
    maxCache: 20,
  },
  actions: {
    [SECRET.GET_NAV](
      { commit, state }: StoreActionEnv<StoreSecretNavState>,
      { filter = 'all', action: rawAction = '' }: { filter: string; action: ActionType },
    ) {
      const cache = findCache(state.cache, filter);
      const cacheUsable = !!cache;
      const action = finalizeAction(rawAction, cacheUsable);
      if (!cache || action === 'reload') {
        return new Promise((resolve, reject) => {
          api.getNav(filter, cacheUsable).then((res) => {
            commit(SECRET.GET_NAV, {
              filter,
              data: {
                navs: res.data,
                group: res.extra.group,
              },
            });
            resolve(res.data);
          }).catch(reject);
        });
      }
      return Promise.resolve(cache.navs);
    },
  },
  mutations: {
    [SECRET.GET_NAV](state: StoreSecretNavState, { filter, data }: { filter: string; data: SecretNavCache }) {
      saveCache(state.cache, filter, data, state.maxCache);
    },
    [SECRET.NAV_BADGE_UPDATE](state: StoreSecretNavState, { type, subType, assign, offset }) {
      if (typeof assign !== 'number' && typeof offset !== 'number') {
        throw new Error('Assign and offset can not both be not numberic!');
      }
      state.cache.forEach((cache) => {
        cache.data.navs.forEach((nav) => {
          nav.items.forEach((menu) => {
            if (menu.type !== type || menu.subType !== subType) {
              return;
            }
            const badge = Math.max(
              typeof assign === 'number'
                ? assign
                : (menu.badge || 0) + offset,
              0,
            );
            menu.badge = badge === 0 ? void 0 : badge;
          });
        });
      });
    },
  },
};
